import { StatType } from "../enums/index.js";

class StatisticalHelper{
    static DetermineMedian(sortedSample)
    {
        if (!(sortedSample instanceof Array)) {
            throw new Error('sortedSample must be an array');
        }

        const count = sortedSample.length;
        if (count === 0) {
            throw new Error('sortedSample cannot be empty');
        }

        const middleIndex = Math.floor((count-1)/2);

        if (count % 2) {
            // odd number, middle is the median
            return sortedSample[middleIndex];
        }

        // even number, calculate avg of 2 medians
        const lower = sortedSample[middleIndex];
        const upper = sortedSample[middleIndex+1];
        return (lower + upper) / 2;
    }

    static DetermineQuartiles(sortedSample)
    {
        // see https://www.varsitytutors.com/algebra_1-help/how-to-find-interquartile-range
        if (!(sortedSample instanceof Array)) {
            throw new Error('sortedSample must be an array');
        }

        const count = sortedSample.length;
        if (count === 0) {
            throw new Error('sortedSample cannot be empty');
        }

        const middleIndex = Math.floor((count-1)/2);
        let lower, upper;
        
        if (count % 2) {
            // odd number, separate into 2 parts skipping middle value
            lower = sortedSample.slice(0, middleIndex);
            upper = sortedSample.slice(middleIndex + 1);
        }
        else {
            // even number, separate into 2 parts
            lower = sortedSample.slice(0, middleIndex + 1);
            upper = sortedSample.slice(middleIndex + 1);
        }

        return {
            [StatType.Q1.key]: StatisticalHelper.DetermineMedian(lower),
            [StatType.Q2.key]: StatisticalHelper.DetermineMedian(sortedSample),
            [StatType.Q3.key]: StatisticalHelper.DetermineMedian(upper),
        };
    }
}

export default StatisticalHelper;